import React, { memo, useEffect } from 'react';
import fitty from 'fitty';

import { StyledProductBadge } from './ProductBadge.styles';

import { ProductBadgeProps } from './ProductBadge.types';

//TODO Remove Duplicate "className" prop (duplicate of "customClassnames")
const ProductBadge = ({
  url,
  text,
  name,
  width,
  className = '',
  componentClassname = 'product-badge',
  customClassnames = '',
  customStyle,
}: ProductBadgeProps) => {
  useEffect(() => {
    fitty('.js-badge-text', {
      minSize: 14,
    });
  }, [text]);

  if (name !== 'discountPercentage' && !url && !text) {
    return null;
  }

  return (
    <StyledProductBadge
      className={`${componentClassname} ${customClassnames} ${className}`}
      data-qa="product-badge"
      data-badge={name}
      url={url}
      text={text}
      width={width}
      customStyle={customStyle}
    >
      <>
        {() => {
          if (name === 'discountPercentage' && text) {
            return (
              <svg
                className={`${componentClassname}__svg`}
                viewBox="-10 -12 53 53"
              >
                <text
                  className={`${componentClassname}__svg-text`}
                  x="35%"
                  y="17"
                  textAnchor="middle"
                >
                  {`${text}%`}
                </text>
                <text
                  className={`${componentClassname}__svg-text ${componentClassname}__svg-text--off`}
                  x="15%"
                  y="31"
                >
                  {'OFF'}
                </text>
              </svg>
            );
          } else if (url) {
            return null;
          } else if (text) {
            return (
              <div className={`${componentClassname}__text-wrapper`}>
                <div className={`js-badge-text ${componentClassname}__text`}>
                  {text}
                </div>
              </div>
            );
          }
        }}
      </>
    </StyledProductBadge>
  );
};
ProductBadge.displayName = 'ProductBadge';

export default memo(ProductBadge);
